import clsx from 'clsx';

/**
 * This util exposes `clsx` to core and extensions as a re-usable utility.
 *
 * For full documentation, see `clsx` on GitHub.
 *
 * @see https://github.com/lukeed/clsx
 */
const classList = clsx;

export default classList;
